import { state } from '../state.js';
import { utils } from '../utils.js';
import { refreshFABVisibility } from '../ui/fab.js';
import { renderAttendanceList, resetAttendanceList} from './attendance.js';


export const renderTopics = (groupId) => {
    state.currentGroup = groupId;
    const topicsContainer = document.getElementById('topicsList');
    if (!topicsContainer) return;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    topicsContainer.innerHTML = '';
    const group = state.getGroupFromLevel(groupId);
    const topicsDays = group.topicDays;

    if (!topicsDays || topicsDays.length === 0) {
        topicsContainer.innerHTML = '<p class="text-center p-3">No topics registered.</p>';
        return;
    }

    const pastTopics = topicsDays
        .filter(td => new Date(td.date + "T00:00:00") <= tomorrow && td.canceled == 0 && state.getTopic(td.topic_id)?.atrium_day !== 0)
        .sort((a, b) => new Date(b.date + "T00:00:00") - new Date(a.date + "T00:00:00"));

    const lastCompletedTopic = pastTopics[0];

    topicsDays.forEach(topicDay => {
        const topic = state.getTopic(topicDay.topic_id);
        const topicDate = new Date(topicDay.date + "T00:00:00");

        const isFuture = topicDate.getTime() > today.getTime();
        const isCanceled = topicDay.canceled == 1;
        const isHoliday = topic && topic.atrium_day === 0;

        let isLastActivated = false;
        if (lastCompletedTopic && topicDay.id === lastCompletedTopic.id) {
            const diffTime = Math.abs(today - topicDate);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            if (diffDays <= 4) {
                isLastActivated = true;
            }
        }

        let stateClass = '';
        if (isCanceled || isHoliday) {
            stateClass = 'topic-item--disabled-dark';
        } else if (isFuture) {
            stateClass = 'topic-item--disabled-light';
        }

        if (isLastActivated) stateClass += ' last-activated';
        
        const canceled = (topicDay.canceled || (topic.atrium_day === 0));

        const topicInfoAndPending = getTopicInfoAndPending(topicDay, (topicDate.getTime() <= tomorrow.getTime()) && !canceled);

        // Definimos el icono o color circular
        let indicatorContent = '';
        let indicatorCls = 'color-';
        if (topicDay.canceled) {
            indicatorContent = '<i class="bi bi-x-circle-fill"></i>';
            indicatorCls = 'color-bi-';
        } else if (topic.atrium_day === 0) {
            indicatorContent = '<i class="bi bi-sign-stop-fill"></i>';
            indicatorCls = 'color-bi-';
        } else if (isLastActivated) {
            indicatorContent = '<i class="bi bi-arrow-right-circle-fill"></i>';
            indicatorCls = 'color-bi-';
        }

        const formattedDate = utils.formatDate(topicDay.date);

        const button = document.createElement('button');

        // Class handling by state (Today, Canceled, Future)
        button.className = `topic-item ${stateClass}`;
        button.dataset.id = topicDay.id;
        button.id = `topic-item-${topicDay.id}`;
        button.innerHTML = `<div class="topic-item__left">
                                <div class="liturgical-indicator ${indicatorCls}${topicDay.liturgical_colour}">
                                    ${indicatorContent}
                                </div>
                                
                                <div class="topic-info">
                                    ${topicInfoAndPending.topicInfo}
                                </div>
                            </div>

                            <div class="topic-item__right">
                                <span class="topic-date">${formattedDate}</span>
                                <div class="topic-pending-wrapper">${topicInfoAndPending.topicPending}</div>
                                <!--i class="bi bi-chevron-right"></i-->
                            </div>
                            `;

        if (!isCanceled && !isHoliday && !isFuture) {
            button.addEventListener('click', () => {
                renderAttendanceList(topicDay);
            });
        }

        topicsContainer.appendChild(button);
    });
    resetAttendanceList();

    setTimeout(() => {
        refreshFABVisibility();
    }, 100);
};

const renderTopicInfo = (topic, canceled, present, displayAbsentCls, absent) => {
    return `<span class="topic-name">${topic ? topic.title : 'Untitled'}</span>
            <div class="topic-stats">
                ${canceled ? '<span class="stat-present">&nbsp;</span>' :
                '<span class="stat-present">Present: ' + present + '</span>' +
                '<span class="stat-absent' + displayAbsentCls + '">Absent: ' + absent + '</span>'}
            </div>`;
};

const renderTopicPending = (displayPendingCls, pending) => `<span class="topic-pending${displayPendingCls}">${pending}</span>`;

const getTopicInfoAndPending = (topicDay, forceNoPending) => {
    const topic = state.getTopic(topicDay.topic_id);
    const total = topicDay.attendance.length;
    const present = topicDay.attendance.filter(a => a.attended === 1).length;
    const absent = topicDay.attendance.filter(a => a.attended === 0).length;
    const pending = forceNoPending ? (total - (present + absent)) : 0;
    const displayAbsentCls = ' stat-absent-' + (absent === 0 ? 'hidden' : 'visible');
    const displayPendingCls = ' topic-pending-' + (pending === 0 ? 'hidden' : 'visible');
    
    const topicInfo = renderTopicInfo(topic, false, present, displayAbsentCls, absent);
    const topicPending = renderTopicPending(displayPendingCls, pending);

    return {
        topicInfo: topicInfo,
        topicPending: topicPending
    };
}

export const refreshTopicInfo = () => {
    const topicDay = state.getCurrentTopicDay();

    const topicInfoAndPending = getTopicInfoAndPending(topicDay, true);

    const button = document.getElementById(`topic-item-${topicDay.id}`);

    button.querySelector('.topic-info').innerHTML = topicInfoAndPending.topicInfo;
    button.querySelector('.topic-pending-wrapper').innerHTML = topicInfoAndPending.topicPending;
}